<template>
 <div :class="windowClass">
   <v-container>
     <template >
      <v-row  no-gutters>
        <v-col cols="12" sm="4" class="pa-1">
           <va-stat-card 
              color="primary"
              icon="mdi-cash-register"
              label="TODAY'S GROSS"
              :data="$money(TOTALGROSS)"
              sup="PHP"
            />
        </v-col>

         <v-col cols="12" sm="4" class="pa-1">
           <va-stat-card 
              color="primary"
              icon="mdi-account-cash-outline"
               label="TODAY'S PAYOUT"
              :data="$money(TOTALPAYOUT)"
              sup="PHP"
            />
        </v-col>

          <v-col cols="12" sm="4" class="pa-1">
           <va-stat-card 
              color="primary"
              icon="mdi-ticket-confirmation"
            label="TODAY'S HITS"
              :data="$money(TOTALHITS)"
            />
        </v-col>
    </v-row>
     </template>
      <v-row class="pa-2">
       
          <v-col cols="12">
             <v-card dense elevation="1">
        <v-toolbar dense elevation="0">
            <span class="font-weight-bold"><v-icon left color="warning">mdi-table</v-icon>Summary</span>
           <v-spacer/>
           As of :<span class="font-weight-bold"> {{ this.$moment().format('MMM DD, YYYY')}}</span>
        </v-toolbar>
        <v-card-text>
          <!-- {{PERGAMES}} -->
             <v-progress-linear
                v-if="loading"
                indeterminate
                color="teal"
                ></v-progress-linear>
            
            <table class="va-table def-font" id="over-table">
                <tr>
                    <!-- <th>DRAW ID</th> -->
                    <td></td>
                    <!-- <th>STATUS</th> -->
                    <!-- <th>DRAW</th> -->
                    <td class="text-right text-primary">GROSS</td>
                    <td class="text-right text-primary">UNIT HITS</td>
                    <td class="text-right text-primary">AMOUNT HITS</td>
                </tr>
                <template v-for="(item,index) in PERGAMES">
                  <tr :key="index + '-c'">
                       <td colspan="4" style="background: #fff;" class="pa-2"></td>
                </tr>
                 <tr :key="index + '-h'">
                  
                    <td class="border_bot" colspan="4" style="background: #fff;">
                      <span class="font-weight-bold text-primary"> {{item.game}} </span>
                    </td>
                   
                </tr>
                <template v-for="(data,_index) in item.data">
                  <tr :key="_index + '-' +index+'-d'">
                      <td class="border_bot">
                        <span class="ml-8"> {{data.draw_time}} - <em :class="STATUS_COLOR('data.status')">{{data.status}}</em></span>
                      </td>
                      <td class="text-right border_bot font-weight-bold">{{$money(data.gross)}}</td>
                      <td class="text-right border_bot font-weight-bold">{{$money(data.amount_of_winning)}}</td>
                      <td class="text-right border_bot font-weight-bold">{{$money(data.payout)}}</td>
                </tr>
              </template>
              </template> 
                <!-- <tr>
                    
                     <th  class="text-right" style="background: #efefef;">TOTAL:</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALGROSS)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALHITS)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALPAYOUT)}}</th>
                </tr> -->
               
            </table>
        </v-card-text>     
    </v-card>
        </v-col>

       
       
       </v-row> 

       <v-row class="pa-2">
         <v-col cols="12">
             <v-card dense>
              <v-toolbar dense elevation="0">
            Today's Operation 
           <v-spacer/>
           As of : {{ this.$moment().format('MMM DD, YYYY')}}
        </v-toolbar>
        <v-card-text>
             <v-progress-linear
                v-if="loading"
                indeterminate
                color="teal"
                ></v-progress-linear>
            
                <table class="va-table def-font" id="over-table">
                <tr>
                 
                    <th>COMMISSION</th>
                    <th class="text-right">GROSS</th>
                    <th class="text-right">COMMISSION</th>
                    <th class="text-right">PAYOUT</th>
                    <th class="text-right">REVENUE</th>
                </tr>
                 <tr v-for="(item,index) in COMMISSIONPERGROUP" :key="index" >
                  <td class="border_bot">{{item.commission}}%</td>
                  <td class="text-right border_bot">{{$money(item_gross(item.data))}}</td>
                  <td class="text-right border_bot">{{$money(item_gross(item.data) * ($IsNum(item.commission)/100))}}</td>
                  <td class="text-right border_bot">{{$money(item_win(item.data))}}</td>
                  <td class="text-right border_bot font-weight-bold">{{$money(item_gross(item.data) - item_win(item.data) - (item_gross(item.data) * ($IsNum(item.commission)/100)))}}</td>
                </tr>
                <tr>
                    
                     <th  class="text-right" style="background: #efefef;">TOTAL:</th>
                      <th class="text-right"  style="background: #efefef;">{{$money(TOTALGROSS)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALCOMM)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALPAYOUT)}}</th>
                    <th class="text-right"  style="background: #efefef;" :class="item_revenvue(TOTALGROSS,TOTALCOMM,TOTALPAYOUT)>-1?'text-success':'text-error'">{{$money(item_revenvue(TOTALGROSS,TOTALCOMM,TOTALPAYOUT))}}</th>
                </tr>
               
            </table>
        </v-card-text>     
    </v-card>
        </v-col>

        <v-col cols="12">
          <v-card dense>
        <v-toolbar dense elevation="0">
           PER CLUSTER
           <v-spacer/>
           As of : {{ this.$moment().format('MMM DD, YYYY')}}
        </v-toolbar>
        <v-card-text>
             <v-progress-linear
                v-if="loading"
                indeterminate
                color="teal"
                ></v-progress-linear>
   
            <table class="va-table def-font" id="over-table">
                <tr>
                    <th>CLUSTER</th>
                    <th class="text-right">GROSS</th>
                    <th class="text-right">UNIT HITS</th>
                    <th class="text-right">AMOUNT HITS</th>
                </tr>
                 <tr v-for="(item,index) in clusters" :key="index" >
                    <td class="border_bot">{{item.cluster?item.cluster:"Others"}} </td>
                    <td class="text-right border_bot">{{$money(item.gross)}}</td>
                    <td class="text-right border_bot">{{$money(item.unit_hits)}}</td>
                    <td class="text-right border_bot">{{$money(item.hits)}}</td>
                </tr>
                <tr>
                     <th  class="text-right" style="background: #efefef;">TOTAL:</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALGROSS)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALHITS)}}</th>
                    <th class="text-right"  style="background: #efefef;">{{$money(TOTALPAYOUT)}}</th>
                </tr>
               
            </table>
        </v-card-text>     
    </v-card>

        </v-col>
      
        
      </v-row>
   </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        overlay: false,
          gross:'',
          loading: false,
          data_open_draws:[],
          commissiongroup:[],
          items:[],
          clusters:[],
          inter_1: null,
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getTransactions()

          this.inter_1 = setInterval(()=>{  this.getTransactions()}, 600000)
        } 
    },
    beforeDestroy(){
       if(this.inter_1 != null) { clearInterval(this.inter_1)}
       return true
    },
    computed:{ 
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      COMMISSIONPERGROUP(){
            var bycommission = this.$groupBy('commission')
            let obj = bycommission(this.commissiongroup)
            let group = []
            Object.keys(obj).forEach(key => {
                group.push({commission:key, data:obj[key]})
            });
        return group
      },
        PERGAMES() {
            var dataArr = []
            var bygames = this.$groupBy('game')
            for (const [key, value] of Object.entries( bygames(this.items))) {
                    var item = { game: key, data:value}
                   dataArr.push(item)
            }
            return dataArr
        },
      TOTALGROSS() {
          var total = this.items.reduce((res,item)=>res += this.$IsNum(item.gross),0)
          return total
      },
        TOTALHITS() {
          var total = this.items.reduce((res,item)=>res += this.$IsNum(item.amount_of_winning),0)
          return total
      },
        TOTALPAYOUT() {
          var total = this.items.reduce((res,item)=>res += this.$IsNum(item.payout),0)
          return total
      },
      TOTALCOMM() {
        var total = this.COMMISSIONPERGROUP.reduce((res,item)=>{
                res =  res+this.item_comm(item)
                return res
        },0)
        return total
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn', 'setOpenDraws']),
      item_revenvue(gross, comm, hits){
        return gross - comm - hits
      },
      item_comm_pergame() {
        return 0
          
      },
      item_comm(line) {
        let commission = this.item_gross(line.data) * (this.$IsNum(line.commission)/100)
        return commission
      },
      item_gross(items) {
          return items.reduce((res,item)=>res += this.$IsNum(item.gross),0)
      },
       item_hits(items) {
          return items.reduce((res,item)=>res += this.$IsNum(item.amount_of_winning),0)
      },
       item_payout(items) {
          return items.reduce((res,item)=>res += this.$IsNum(item.payout),0)
      },
      item_win(items) {
          return items.reduce((res,item)=>res += this.$IsNum(item.win_amount),0)
      },
      calculate(percent, gross){
        var comm = this.$IsNum(gross) * (this.$IsNum(percent)/100)
        return  comm
      },
      getPerCluster(){
            this.loading = true
            this.clusters =[]
            var param = {}
            param.from_date =this.$moment().format('YYYY-MM-DD')
            param.to_date = this.$moment().format('YYYY-MM-DD')
            param.method = "percluster"
             this.$http.post("report/transactions",param).then(response => {
                response.data.transactions !=null?this.clusters = response.data.transactions:this.clusters =[]
             
                
          }).catch(e => {
            console.log(e.data)
          })
        },
      getPerCom(){
            this.loading = true
            this.commissiongroup =[]
            var param = {}
            param.from_date = this.$moment().format('YYYY-MM-DD')
            param.to_date = this.$moment().format('YYYY-MM-DD')
            param.Method = "daily_coordinator_summary"
             this.$http.post("report/transactions",param).then(response => {
                response.data.items !=null?this.commissiongroup = response.data.items:this.commissiongroup =[]
                this.loading = false
              
          }).catch(e => {
            console.log(e.data)
          })
        }, 
      getTransactions(){
       //alert("call")
            this.loading = true
            this.items =[]
            var param = {}
            param.from_date = this.$moment().format('YYYY-MM-DD')
            param.to_date =  param.from_date
            param.Method = "perdraw"
             this.$http.post("report/transactions",param).then(response => {
                response.data.transactions !=null?this.items = response.data.transactions:this.items =[]
               this.getPerCom()
               this.getPerCluster()
                this.loading = false
          }).catch(e => {
            console.log(e.data)
          })
        },   
    }
  }
</script>